import React from 'react';
import { Text, Button } from 'rebass';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ModalContent from '../ModalContent';

interface NotificationModalProps {
  closeModalHandler: VoidFunction;
}

const Content = styled(ModalContent)`
  flex-direction: column;
  padding: 35px;
`;

const FormButton = styled(Button)`
  width: 150px;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
`;

const NotificationModal: React.FC<NotificationModalProps> = ({ closeModalHandler }) => {
  const { data } = useSelector<any, any>(state => state.modal);

  return (
    <Content>
      <Text>{data.explanation}</Text>
      <FormButton variant="primary" onClick={closeModalHandler}>
        OK
      </FormButton>
    </Content>
  );
};

export default NotificationModal;
